// extracted by mini-css-extract-plugin
export default {"rowWrapper":"giftCardWalletLoadingCell_rowWrapper__6DTLI"};